import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fixed inset-0 flex items-center justify-center z-50" }
const _hoisted_2 = { class: "bg-gray-800 text-white rounded-lg shadow-xl border border-gray-700 p-5 max-w-md z-10 w-full mx-4 md:w-auto transform transition-all duration-300 scale-100" }
const _hoisted_3 = { class: "flex justify-between items-start mb-5" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-xl font-medium text-white" }
const _hoisted_6 = { class: "text-red-400" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_9 = { class: "mb-5" }
const _hoisted_10 = { class: "flex justify-between mt-1" }
const _hoisted_11 = {
  key: 0,
  class: "text-sm text-red-400 flex items-center"
}
const _hoisted_12 = { class: "text-xs text-gray-400 ml-auto" }
const _hoisted_13 = { class: "flex justify-between space-x-3 mt-6" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_16 = {
  key: 1,
  class: "animate-spin h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "bg-red-500 p-2 rounded-lg mr-3" }, [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "h-6 w-6 text-white",
              viewBox: "0 0 20 20",
              fill: "currentColor"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                "clip-rule": "evenodd"
              })
            ])
          ], -1)),
          _createElementVNode("h3", _hoisted_5, [
            _cache[8] || (_cache[8] = _createTextVNode(" Prijavi korisnika ")),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.reportedUsername), 1)
          ])
        ]),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "text-gray-400 hover:text-gray-300 transition-colors bg-gray-700 hover:bg-gray-600 rounded-full p-1.5"
        }, _cache[10] || (_cache[10] = [
          _createElementVNode("svg", {
            class: "h-5 w-5",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
              "clip-rule": "evenodd"
            })
          ], -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-sm text-gray-300 mb-2" }, "Razlog prijave:", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reportData.reason = 'spam')),
            class: _normalizeClass(["p-2 rounded-lg text-sm transition-colors", 
              _ctx.reportData.reason === 'spam'
                ? 'bg-red-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            ])
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("div", { class: "flex items-center justify-center" }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4 mr-1",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                  "clip-rule": "evenodd"
                })
              ]),
              _createTextVNode(" Spam ")
            ], -1)
          ]), 2),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reportData.reason = 'harassment')),
            class: _normalizeClass(["p-2 rounded-lg text-sm transition-colors", 
              _ctx.reportData.reason === 'harassment'
                ? 'bg-red-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            ])
          }, _cache[12] || (_cache[12] = [
            _createElementVNode("div", { class: "flex items-center justify-center" }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4 mr-1",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M2.94 6.412A2 2 0 002 8.108V16a2 2 0 002 2h12a2 2 0 002-2V8.108a2 2 0 00-.94-1.696l-6-3.75a2 2 0 00-2.12 0l-6 3.75zm2.615 2.423a1 1 0 10-1.11 1.664l5 3.333a1 1 0 001.11 0l5-3.333a1 1 0 00-1.11-1.664L10 11.798 5.555 8.835z",
                  "clip-rule": "evenodd"
                })
              ]),
              _createTextVNode(" Uznemiravanje ")
            ], -1)
          ]), 2),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reportData.reason = 'fake_profile')),
            class: _normalizeClass(["p-2 rounded-lg text-sm transition-colors", 
              _ctx.reportData.reason === 'fake_profile'
                ? 'bg-red-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            ])
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("div", { class: "flex items-center justify-center" }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4 mr-1",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z",
                  "clip-rule": "evenodd"
                })
              ]),
              _createTextVNode(" Lažni profil ")
            ], -1)
          ]), 2),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reportData.reason = 'other')),
            class: _normalizeClass(["p-2 rounded-lg text-sm transition-colors", 
              _ctx.reportData.reason === 'other'
                ? 'bg-red-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            ])
          }, _cache[14] || (_cache[14] = [
            _createElementVNode("div", { class: "flex items-center justify-center" }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4 mr-1",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z",
                  "clip-rule": "evenodd"
                })
              ]),
              _createTextVNode(" Drugo ")
            ], -1)
          ]), 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[17] || (_cache[17] = _createElementVNode("label", {
          for: "reportDescription",
          class: "block text-sm text-gray-300 mb-2"
        }, "Opis problema:", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "reportDescription",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reportData.description) = $event)),
          class: _normalizeClass(["w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors", { 'border-red-500 ring-1 ring-red-500': _ctx.validationError }]),
          rows: "3",
          placeholder: "Detaljno opišite problem koji imate sa ovim korisnikom..."
        }, null, 2), [
          [_vModelText, _ctx.reportData.description]
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.validationError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                _cache[16] || (_cache[16] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-4 w-4 mr-1",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                    "clip-rule": "evenodd"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.validationError), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.reportData.description.length) + "/100 karaktera ", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close'))),
          class: "px-5 py-2.5 bg-gray-700 text-gray-300 rounded-lg hover:bg-gray-600 transition-colors font-medium"
        }, " Otkaži "),
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitReport && _ctx.submitReport(...args))),
          class: "px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium flex items-center space-x-2",
          disabled: _ctx.isSubmitting
        }, [
          (!_ctx.isSubmitting)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[18] || (_cache[18] = [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                  "clip-rule": "evenodd"
                }, null, -1)
              ])))
            : _createCommentVNode("", true),
          (_ctx.isSubmitting)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[19] || (_cache[19] = [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }, null, -1),
                _createElementVNode("path", {
                  class: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                }, null, -1)
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Slanje prijave...' : 'Prijavi korisnika'), 1)
        ], 8, _hoisted_14)
      ])
    ])
  ]))
}